export enum LocalstorageKey {
  Animation = 'Animation',
  FontawesomeType = 'FontawesomeType',
  Authentication = 'Authentication',
  Language = 'Language'
}
